import $ from 'jquery';
import 'babel-polyfill';
import 'intersection-observer';
import 'focus-visible';

import initializeShared from '../shared';
import {NotificationManager} from './modules';

import {
  initializeMarketingAssets,
  initializeExpandableContent,
  initializeShopifyYCookie,
  initializeSubscriptionWithCookie,
  initializeSubscriptionPopup,
  initializeTrackListingView,
} from './initializers';

import {smoothScroll} from './utilities/smooth-scroll';
import {trackClicks as trackFacebookPixelClicks} from './utilities/facebook-pixel';
import {incrementPageCount} from './utilities/page-counter';

window.initMarketplace =
  window.initMarketplace ||
  function() {
    initializeMarketingAssets();
    incrementPageCount();
    initializeExpandableContent();
    initializeShared();
    trackFacebookPixelClicks();
    new NotificationManager();
    initializeShopifyYCookie();
    initializeSubscriptionWithCookie();
    initializeSubscriptionPopup();
    initializeTrackListingView();
    smoothScroll();
  };

$(() => {
  window.initMarketplace();
  window.initMarketplace = () => {};
});
